export default class RendicontazioneFilter {
  constructor() {
    this.projectId = null
    this.employee = null
    this.date = null
  }
}
